export const getError = e => {
	if (e.response && e.response.data && e.response.data.validation_errors && Object.keys(e.response.data.validation_errors).length) {
		const errors = e.response.data.validation_errors

		return errors[Object.keys(errors)[0]][0]
	}

	return null
}
